module.exports = __webpack_public_path__ + "img/coins-agree-confirm.33394223.png";